import { getCookieValue } from './get-cookie-value';

export function getDynamicConfigVariantName(payload: {
    hostname: string;
    port: string;
}): {
    variantName: string;
    variantNameForApp: string;
} {
    const { hostname, port } = payload;
    if (hostname.endsWith(`localhost.siriusxm.com`)) {
        const cookie = getCookieValue(`variantName${port}`);
        if (cookie) {
            return JSON.parse(cookie);
        }
        return {
            variantName: '',
            variantNameForApp: '',
        };
    }
    return {
        variantName: getVariantName({
            ...payload,
            regex: /(variant-([a-z0-9-]*))/gi,
        }),
        variantNameForApp: getVariantName({
            ...payload,
            regex: /(variantapp-([a-z0-9-]*))/gi,
        }),
    };
}

function getVariantName({
    hostname,
    regex,
}: {
    regex: RegExp;
    hostname: string;
    port: string;
}) {
    const subdomainPartWithVariant = hostname
        .split('.')
        ?.find(
            (piece) =>
                piece.includes('variant-') || piece.includes('variantapp-'),
        );
    if (!subdomainPartWithVariant) {
        return '';
    }
    let results = '';
    let m: RegExpExecArray | null;
    while ((m = regex.exec(subdomainPartWithVariant)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m?.index === regex.lastIndex) {
            regex.lastIndex++;
        }

        // The result can be accessed through the `m`-variable.
        m?.forEach((match, groupIndex) => {
            if (groupIndex === 2 && m?.[groupIndex]) {
                results = m[groupIndex];
            }
        });
    }
    // TODO: figure out regex so the match does not need to contain the extra stuff.
    return results.split('--')?.[0];
}
